import React from "react";
import { useHistory } from "react-router-dom";
import Content from "../../base/layout/content/Content";
import { Message404Page } from "../../ui";
import { getNotFound404IllustrationSrc } from "./illustration404Src";

const E404 = () => {
    const history = useHistory();

    return (
        <Content>
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    minHeight: "50vh",
                    padding: "24px 16px",
                }}
            >
                <Message404Page
                    imageSrc={getNotFound404IllustrationSrc()}
                    onGoHome={() => history.push("/")}
                />
            </div>
        </Content>
    );
};

export default E404;
